import Button from '@mui/material/Button'
import { Typography } from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const SnsButton = ({ link, color, icon, name }) => (
  <Button
    href={link}
    target="_blank"
    variant="outlined"
    color={color}
    size="small"
    sx={{
      width: { xs: 80, sm: 90, md: 100 },
      minWidth: 'auto',
      px: 1
    }}
  >
    <FontAwesomeIcon icon={icon} fontSize="small" />
    <Typography
      sx={{
        ml: 1,
        fontSize: { xs: '11px', sm: '12px', md: '13px' },
        textTransform: 'capitalize',
      }}
    >
      {name}
    </Typography>
  </Button>
)

export default SnsButton 